export const cases = {
  extends: 'Page',
  flow: 'x',
  minHeight: '100vh',
  background: 'surface',
  Sidebar: {},

  MainContent: {
    flow: 'y',
    flex: '1',
    padding: 'B C',
    gap: 'A',
    overflow: 'auto',
    '@tabletS': { padding: 'A B' },
    '@mobileL': { padding: 'A' },

    PageHeader: {
      flow: 'x',
      align: 'center space-between',
      gap: 'A',
      flexWrap: 'wrap',
      '@mobileL': { flow: 'y', gap: 'A' },
      HeaderTitle: {
        tag: 'h1',
        text: '{{ casesTitle | polyglot }}',
        fontSize: 'C',
        fontWeight: '800',
        color: 'text',
        whiteSpace: 'nowrap',
        '@mobileL': { fontSize: 'B' }
      },
      HeaderRight: {
        flow: 'x',
        gap: 'Z',
        align: 'center',
        flexShrink: '0',
        '@mobileL': { flexWrap: 'wrap', width: '100%' },
        SearchInput: {
          tag: 'input',
          type: 'text',
          name: 'search',
          placeholder: '{{ searchPlaceholder2 | polyglot }}',
          padding: 'Y Z',
          fontSize: 'Z',
          background: 'surfaceCard',
          border: '1px solid surfaceBorderStrong',
          borderRadius: 'Z',
          color: 'text',
          outline: 'none',
          width: 'E',
          minWidth: 'D'
        },
        NewCaseBtn: {
          extends: 'Button',
          text: '{{ newCase | polyglot }}',
          background: 'green',
          color: 'neutral950',
          border: 'none',
          fontWeight: '600',
          padding: 'Y Z',
          fontSize: 'Z',
          borderRadius: 'Z',
          cursor: 'pointer',
          whiteSpace: 'nowrap',
          onClick: (e, el, s) =>
            s.root.update({ activeCaseId: null, detailTab: 'info' })
        },
        ThemeToggle: {}
      }
    },

    // Filter tabs + integration pills
    FilterBar: {
      flow: 'x',
      gap: 'Z',
      align: 'center space-between',
      '@mobileL': { flexWrap: 'wrap', gap: 'Y' },
      TabsRow: {
        flow: 'x',
        gap: 'Z',
        TabAll: {
          extends: 'Button',
          text: '{{ allTab | polyglot }}',
          padding: 'Z A',
          fontSize: 'Z',
          borderRadius: 'Z',
          cursor: 'pointer',
          background: (el, s) =>
            s.root.activeTab === 'all' ? 'green' : 'surfaceBorder',
          color: (el, s) => (s.root.activeTab === 'all' ? 'black' : 'textSoft'),
          fontWeight: (el, s) => (s.root.activeTab === 'all' ? '700' : '400'),
          onClick: (e, el, s) => s.root.update({ activeTab: 'all' })
        },
        TabActive: {
          extends: 'Button',
          text: '{{ activeTab | polyglot }}',
          padding: 'Z A',
          fontSize: 'Z',
          borderRadius: 'Z',
          cursor: 'pointer',
          background: (el, s) =>
            s.root.activeTab === 'active' ? 'green' : 'surfaceBorder',
          color: (el, s) =>
            s.root.activeTab === 'active' ? 'black' : 'textSoft',
          fontWeight: (el, s) =>
            s.root.activeTab === 'active' ? '700' : '400',
          onClick: (e, el, s) => s.root.update({ activeTab: 'active' })
        },
        TabPending: {
          extends: 'Button',
          text: '{{ pendingTab | polyglot }}',
          padding: 'Z A',
          fontSize: 'Z',
          borderRadius: 'Z',
          cursor: 'pointer',
          background: (el, s) =>
            s.root.activeTab === 'pending' ? 'green' : 'surfaceBorder',
          color: (el, s) =>
            s.root.activeTab === 'pending' ? 'black' : 'textSoft',
          fontWeight: (el, s) =>
            s.root.activeTab === 'pending' ? '700' : '400',
          onClick: (e, el, s) => s.root.update({ activeTab: 'pending' })
        },
        TabClosed: {
          extends: 'Button',
          text: '{{ closedTab | polyglot }}',
          padding: 'Z A',
          fontSize: 'Z',
          borderRadius: 'Z',
          cursor: 'pointer',
          background: (el, s) =>
            s.root.activeTab === 'closed' ? 'green' : 'surfaceBorder',
          color: (el, s) =>
            s.root.activeTab === 'closed' ? 'black' : 'textSoft',
          fontWeight: (el, s) =>
            s.root.activeTab === 'closed' ? '700' : '400',
          onClick: (e, el, s) => s.root.update({ activeTab: 'closed' })
        }
      },
      IntPills: {
        flow: 'x',
        gap: 'Y',
        align: 'center',
        EcourtPill: {
          flow: 'x',
          gap: 'Y',
          align: 'center',
          padding: 'Y Z',
          borderRadius: 'Z',
          cursor: 'pointer',
          background: (el, s) =>
            s.root.detailTab === 'ecourt' ? 'greenBg' : 'transparent',
          border: (el, s) =>
            s.root.detailTab === 'ecourt'
              ? '1px solid green'
              : '1px solid surfaceBorderStrong',
          transition: 'all 150ms',
          ':hover': { borderColor: 'green' },
          onClick: (e, el, s) =>
            s.root.update({
              detailTab: s.root.detailTab === 'ecourt' ? 'info' : 'ecourt'
            }),
          PillIcon: { text: '⚖️', fontSize: 'Y' },
          PillLabel: {
            text: 'ecourt',
            fontSize: 'Y',
            color: (el, s) =>
              s.root.detailTab === 'ecourt' ? 'green' : 'textMuted',
            fontWeight: '500'
          }
        },
        ReestryPill: {
          flow: 'x',
          gap: 'Y',
          align: 'center',
          padding: 'Y Z',
          borderRadius: 'Z',
          cursor: 'pointer',
          background: (el, s) =>
            s.root.detailTab === 'reestry' ? 'blueBg' : 'transparent',
          border: (el, s) =>
            s.root.detailTab === 'reestry'
              ? '1px solid blue'
              : '1px solid surfaceBorderStrong',
          transition: 'all 150ms',
          ':hover': { borderColor: 'blue' },
          onClick: (e, el, s) =>
            s.root.update({
              detailTab: s.root.detailTab === 'reestry' ? 'info' : 'reestry'
            }),
          PillIcon: { text: '🏛️', fontSize: 'Y' },
          PillLabel: {
            text: '{{ registry | polyglot }}',
            fontSize: 'Y',
            color: (el, s) =>
              s.root.detailTab === 'reestry' ? 'blue' : 'textMuted',
            fontWeight: '500'
          }
        },
        MatsnePill: {
          flow: 'x',
          gap: 'Y',
          align: 'center',
          padding: 'Y Z',
          borderRadius: 'Z',
          cursor: 'pointer',
          background: (el, s) =>
            s.root.detailTab === 'matsne' ? 'purpleBg' : 'transparent',
          border: (el, s) =>
            s.root.detailTab === 'matsne'
              ? '1px solid purple'
              : '1px solid surfaceBorderStrong',
          transition: 'all 150ms',
          ':hover': { borderColor: 'purple' },
          onClick: (e, el, s) =>
            s.root.update({
              detailTab: s.root.detailTab === 'matsne' ? 'info' : 'matsne'
            }),
          PillIcon: { text: '📜', fontSize: 'Y' },
          PillLabel: {
            text: 'matsne',
            fontSize: 'Y',
            color: (el, s) =>
              s.root.detailTab === 'matsne' ? 'purple' : 'textMuted',
            fontWeight: '500'
          }
        }
      }
    },

    // Two-column layout
    CasesContent: {
      flow: 'x',
      gap: 'B',
      flex: '1',
      alignItems: 'flex-start',
      '@tabletS': { flow: 'y' },

      // Left: Cases list
      CasesList: {
        flow: 'y',
        gap: 'Z',
        flex: '1',

        CaseRow1: {
          flow: 'x',
          align: 'center space-between',
          padding: 'A',
          background: (el, s) =>
            s.root.activeCaseId === 1 ? 'greenBg' : 'surfaceCard',
          border: (el, s) =>
            s.root.activeCaseId === 1
              ? '1px solid greenBorder'
              : '1px solid surfaceBorderStrong',
          borderRadius: 'Z',
          cursor: 'pointer',
          transition: 'background 150ms, border 150ms',
          show: (el, s) =>
            s.root.activeTab === 'all' || s.root.activeTab === 'active',
          onClick: (e, el, s) =>
            s.root.update({ activeCaseId: 1, detailTab: 'info' }),
          CaseMainInfo: {
            flow: 'y',
            gap: 'Z',
            CaseNumClient: {
              text: '{{ caseRow1Title | polyglot }}',
              fontSize: 'A',
              fontWeight: '600',
              color: 'text'
            },
            CaseMetaRow: {
              flow: 'x',
              gap: 'Z',
              align: 'center',
              TypeBadge: {
                tag: 'span',
                text: '{{ typeCivil | polyglot }}',
                fontSize: 'Y',
                padding: 'Y Z',
                background: 'blueBg',
                border: '1px solid blueBorder',
                borderRadius: 'Z',
                color: 'blue'
              },
              UpdateDate: {
                text: '{{ dateMar18 | polyglot }}',
                fontSize: 'Z',
                color: 'textMuted'
              }
            }
          },
          RowStatus: {
            extends: 'StatusActive',
            text: '{{ activeTab | polyglot }}'
          }
        },

        CaseRow2: {
          flow: 'x',
          align: 'center space-between',
          padding: 'A',
          background: (el, s) =>
            s.root.activeCaseId === 2 ? 'greenBg' : 'surfaceCard',
          border: (el, s) =>
            s.root.activeCaseId === 2
              ? '1px solid greenBorder'
              : '1px solid surfaceBorderStrong',
          borderRadius: 'Z',
          cursor: 'pointer',
          transition: 'background 150ms, border 150ms',
          show: (el, s) =>
            s.root.activeTab === 'all' || s.root.activeTab === 'pending',
          onClick: (e, el, s) =>
            s.root.update({ activeCaseId: 2, detailTab: 'info' }),
          CaseMainInfo: {
            flow: 'y',
            gap: 'Z',
            CaseNumClient: {
              text: '{{ caseRow2Title | polyglot }}',
              fontSize: 'A',
              fontWeight: '600',
              color: 'text'
            },
            CaseMetaRow: {
              flow: 'x',
              gap: 'Z',
              align: 'center',
              TypeBadge: {
                tag: 'span',
                text: '{{ typeAdministrative | polyglot }}',
                fontSize: 'Y',
                padding: 'Y Z',
                background: 'purpleBg',
                border: '1px solid purpleBorder',
                borderRadius: 'Z',
                color: 'purple'
              },
              UpdateDate: {
                text: '{{ dateMar17 | polyglot }}',
                fontSize: 'Z',
                color: 'textMuted'
              }
            }
          },
          RowStatus: {
            extends: 'StatusPending',
            text: '{{ pendingTab | polyglot }}'
          }
        },

        CaseRow3: {
          flow: 'x',
          align: 'center space-between',
          padding: 'A',
          background: (el, s) =>
            s.root.activeCaseId === 3 ? 'greenBg' : 'surfaceCard',
          border: (el, s) =>
            s.root.activeCaseId === 3
              ? '1px solid greenBorder'
              : '1px solid surfaceBorderStrong',
          borderRadius: 'Z',
          cursor: 'pointer',
          transition: 'background 150ms, border 150ms',
          show: (el, s) =>
            s.root.activeTab === 'all' || s.root.activeTab === 'closed',
          onClick: (e, el, s) =>
            s.root.update({ activeCaseId: 3, detailTab: 'info' }),
          CaseMainInfo: {
            flow: 'y',
            gap: 'Z',
            CaseNumClient: {
              text: '{{ caseRow3Title | polyglot }}',
              fontSize: 'A',
              fontWeight: '600',
              color: 'text'
            },
            CaseMetaRow: {
              flow: 'x',
              gap: 'Z',
              align: 'center',
              TypeBadge: {
                tag: 'span',
                text: '{{ typeCriminal | polyglot }}',
                fontSize: 'Y',
                padding: 'Y Z',
                background: 'redBg',
                border: '1px solid redBorder',
                borderRadius: 'Z',
                color: 'red'
              },
              UpdateDate: {
                text: '{{ dateMar15 | polyglot }}',
                fontSize: 'Z',
                color: 'textMuted'
              }
            }
          },
          RowStatus: {
            extends: 'StatusClosed',
            text: '{{ closedTab | polyglot }}'
          }
        },

        // Empty state hint
        SelectHint: {
          flow: 'y',
          align: 'center center',
          padding: 'C',
          gap: 'Z',
          show: (el, s) => s.root.activeCaseId === null,
          HintIcon: { text: '←', fontSize: 'C', color: 'textMuted' },
          HintText: {
            text: '{{ selectCasePrompt | polyglot }}',
            fontSize: 'A',
            color: 'textMuted',
            textAlign: 'center'
          }
        }
      },

      // Right: Case detail with tabbed content
      CaseDetail: {
        flow: 'y',
        gap: 'A',
        flex: '1',
        padding: 'A',
        minWidth: 'G3',
        maxWidth: 'H',
        '@tabletS': { maxWidth: '100%', width: '100%' },
        background: 'surfaceMid',
        border: '1px solid surfaceBorderStrong',
        borderRadius: 'Z',
        if: (el, s) => s.root.activeCaseId !== null,
        overflow: 'auto',
        maxHeight: '80vh',

        // Header
        DetailHeader: {
          flow: 'x',
          align: 'center space-between',
          DetailLeft: {
            flow: 'y',
            gap: 'Y',
            DetailTitle: {
              text: (el, s) => {
                if (s.root.activeCaseId === 1)
                  return '{{ caseRow1Title | polyglot }}'
                if (s.root.activeCaseId === 2)
                  return '{{ caseRow2Title | polyglot }}'
                return '{{ caseRow3Title | polyglot }}'
              },
              fontSize: 'A',
              fontWeight: '700',
              color: 'text'
            },
            StatusRow: {
              flow: 'x',
              gap: 'Z',
              align: 'center',
              Case1Status: {
                extends: 'StatusActive',
                text: '{{ activeTab | polyglot }}',
                show: (el, s) => s.root.activeCaseId === 1
              },
              Case2Status: {
                extends: 'StatusPending',
                text: '{{ pendingTab | polyglot }}',
                show: (el, s) => s.root.activeCaseId === 2
              },
              Case3Status: {
                extends: 'StatusClosed',
                text: '{{ closedTab | polyglot }}',
                show: (el, s) => s.root.activeCaseId === 3
              }
            }
          },
          CloseBtn: {
            text: '✕',
            background: 'transparent',
            border: 'none',
            color: 'textSoft',
            fontSize: 'A',
            padding: 'Z',
            cursor: 'pointer',
            onClick: (e, el, s) => s.root.update({ activeCaseId: null })
          }
        },

        // Detail tabs: info, ecourt, reestry, matsne
        DetailTabs: {
          flow: 'x',
          gap: 'Y',
          borderBottom: '1px solid surfaceBorderStrong',
          padding: '0 0 Z 0',
          '@mobileL': { flexWrap: 'wrap' },
          TabInfo: {
            text: '{{ info | polyglot }}',
            padding: 'Y Z',
            fontSize: 'Z',
            cursor: 'pointer',
            borderRadius: 'Y',
            background: (el, s) =>
              s.root.detailTab === 'info' ? 'green' : 'transparent',
            color: (el, s) =>
              s.root.detailTab === 'info' ? 'neutral950' : 'textSoft',
            fontWeight: (el, s) =>
              s.root.detailTab === 'info' ? '600' : '400',
            onClick: (e, el, s) => s.root.update({ detailTab: 'info' })
          },
          TabEcourt: {
            flow: 'x',
            gap: 'Y',
            align: 'center',
            padding: 'Y Z',
            fontSize: 'Z',
            cursor: 'pointer',
            borderRadius: 'Y',
            background: (el, s) =>
              s.root.detailTab === 'ecourt' ? 'greenBg' : 'transparent',
            color: (el, s) =>
              s.root.detailTab === 'ecourt' ? 'green' : 'textMuted',
            fontWeight: (el, s) =>
              s.root.detailTab === 'ecourt' ? '600' : '400',
            border: (el, s) =>
              s.root.detailTab === 'ecourt'
                ? '1px solid greenBorder'
                : '1px solid transparent',
            onClick: (e, el, s) => s.root.update({ detailTab: 'ecourt' }),
            PillIcon: { text: '⚖️', fontSize: 'Y' },
            PillLabel: { text: '{{ ecourt | polyglot }}' }
          },
          TabReestry: {
            flow: 'x',
            gap: 'Y',
            align: 'center',
            padding: 'Y Z',
            fontSize: 'Z',
            cursor: 'pointer',
            borderRadius: 'Y',
            background: (el, s) =>
              s.root.detailTab === 'reestry' ? 'blueBg' : 'transparent',
            color: (el, s) =>
              s.root.detailTab === 'reestry' ? 'blue' : 'textMuted',
            fontWeight: (el, s) =>
              s.root.detailTab === 'reestry' ? '600' : '400',
            border: (el, s) =>
              s.root.detailTab === 'reestry'
                ? '1px solid blueBorder'
                : '1px solid transparent',
            onClick: (e, el, s) => s.root.update({ detailTab: 'reestry' }),
            PillIcon: { text: '🏛️', fontSize: 'Y' },
            PillLabel: { text: '{{ registry | polyglot }}' }
          },
          TabMatsne: {
            flow: 'x',
            gap: 'Y',
            align: 'center',
            padding: 'Y Z',
            fontSize: 'Z',
            cursor: 'pointer',
            borderRadius: 'Y',
            background: (el, s) =>
              s.root.detailTab === 'matsne' ? 'purpleBg' : 'transparent',
            color: (el, s) =>
              s.root.detailTab === 'matsne' ? 'purple' : 'textMuted',
            fontWeight: (el, s) =>
              s.root.detailTab === 'matsne' ? '600' : '400',
            border: (el, s) =>
              s.root.detailTab === 'matsne'
                ? '1px solid purpleBorder'
                : '1px solid transparent',
            onClick: (e, el, s) => s.root.update({ detailTab: 'matsne' }),
            PillIcon: { text: '📜', fontSize: 'Y' },
            PillLabel: { text: '{{ matsne | polyglot }}' }
          }
        },

        // ═══ Tab: Info ═══
        InfoContent: {
          flow: 'y',
          gap: 'A',
          show: (el, s) => s.root.detailTab === 'info',

          ClientInfo: {
            flow: 'y',
            gap: 'Z',
            padding: 'A',
            background: 'surfaceCard',
            border: '1px solid surfaceBorder',
            borderRadius: 'Z',
            InfoLabel: {
              text: '{{ clientInfo | polyglot }}',
              fontSize: 'Z',
              fontWeight: '600',
              color: 'textMuted'
            },
            InfoName: {
              text: (el, s) => {
                if (s.root.activeCaseId === 1)
                  return '{{ clientName1 | polyglot }}'
                if (s.root.activeCaseId === 2)
                  return '{{ clientName2 | polyglot }}'
                return '{{ clientName3 | polyglot }}'
              },
              fontSize: 'A',
              fontWeight: '600',
              color: 'text'
            },
            ContactRow: {
              flow: 'x',
              gap: 'B',
              flexWrap: 'wrap',
              PhoneInfo: {
                flow: 'x',
                gap: 'Z',
                align: 'center',
                PhoneIcon: {
                  extends: 'Icon',
                  icon: 'phone',
                  width: 'Z',
                  height: 'Z',
                  color: 'textMuted'
                },
                PhoneText: {
                  text: '+995 555 123 456',
                  fontSize: 'Z',
                  color: 'textSoft'
                }
              },
              EmailInfo: {
                flow: 'x',
                gap: 'Z',
                align: 'center',
                MailIcon: {
                  extends: 'Icon',
                  icon: 'mail',
                  width: 'Z',
                  height: 'Z',
                  color: 'textMuted'
                },
                EmailText: {
                  text: (el, s) => {
                    if (s.root.activeCaseId === 1) return 'giorgi@mail.ge'
                    if (s.root.activeCaseId === 2) return 'mariam@mail.ge'
                    return 'lela@mail.ge'
                  },
                  fontSize: 'Z',
                  color: 'textSoft'
                }
              }
            }
          },

          TimelineSection: {
            flow: 'y',
            gap: 'Z',
            TimelineTitle: {
              text: '{{ chronology | polyglot }}',
              fontSize: 'A',
              fontWeight: '600',
              color: 'text',
              padding: '0 0 Z 0'
            },
            TimeEntry1: {
              flow: 'x',
              gap: 'A',
              padding: 'Z A',
              borderLeft: '2px solid green',
              TimeDot: {
                width: 'Y',
                height: 'Y',
                borderRadius: '100%',
                background: 'green',
                flexShrink: '0',
                marginTop: 'X'
              },
              EntryContent: {
                flow: 'y',
                gap: 'Z',
                EntryDate: {
                  text: '{{ timeEntry1Date | polyglot }}',
                  fontSize: 'Y',
                  color: 'textMuted',
                  fontWeight: '500'
                },
                EntryText: {
                  text: '{{ timeEntry1Text | polyglot }}',
                  fontSize: 'Z',
                  color: 'textSoft',
                  lineHeight: '1.5'
                }
              }
            },
            TimeEntry2: {
              flow: 'x',
              gap: 'A',
              padding: 'Z A',
              borderLeft: '2px solid surfaceBorderStrong',
              TimeDot: {
                width: 'Y',
                height: 'Y',
                borderRadius: '100%',
                background: 'surfaceBorderStrong',
                flexShrink: '0',
                marginTop: 'X'
              },
              EntryContent: {
                flow: 'y',
                gap: 'Z',
                EntryDate: {
                  text: '{{ timeEntry2Date | polyglot }}',
                  fontSize: 'Y',
                  color: 'textMuted',
                  fontWeight: '500'
                },
                EntryText: {
                  text: '{{ timeEntry2Text | polyglot }}',
                  fontSize: 'Z',
                  color: 'textSoft',
                  lineHeight: '1.5'
                }
              }
            },
            TimeEntry3: {
              flow: 'x',
              gap: 'A',
              padding: 'Z A',
              borderLeft: '2px solid surfaceBorderStrong',
              TimeDot: {
                width: 'Y',
                height: 'Y',
                borderRadius: '100%',
                background: 'surfaceBorderStrong',
                flexShrink: '0',
                marginTop: 'X'
              },
              EntryContent: {
                flow: 'y',
                gap: 'Z',
                EntryDate: {
                  text: '{{ timeEntry3Date | polyglot }}',
                  fontSize: 'Y',
                  color: 'textMuted',
                  fontWeight: '500'
                },
                EntryText: {
                  text: '{{ timeEntry3Text | polyglot }}',
                  fontSize: 'Z',
                  color: 'textSoft',
                  lineHeight: '1.5'
                }
              }
            }
          },

          AddNoteSection: {
            flow: 'y',
            gap: 'Z',
            padding: 'A 0 0 0',
            borderTop: '1px solid surfaceBorderStrong',
            NoteTitle: {
              text: '{{ addNote | polyglot }}',
              fontSize: 'A',
              fontWeight: '600',
              color: 'text',
              padding: 'Z 0'
            },
            NoteInput: {
              tag: 'textarea',
              name: 'note',
              placeholder: '{{ enterNote | polyglot }}',
              padding: 'Z',
              fontSize: 'Z',
              background: 'surfaceCard',
              border: '1px solid surfaceBorderStrong',
              borderRadius: 'Z',
              color: 'text',
              minHeight: 'C'
            },
            AddNoteBtn: {
              extends: 'Button',
              text: '{{ addBtn | polyglot }}',
              background: 'green',
              color: 'neutral950',
              border: 'none',
              fontWeight: '600',
              padding: 'Z A',
              fontSize: 'Z',
              borderRadius: 'Z',
              cursor: 'pointer'
            }
          },

          DocsSection: {
            flow: 'y',
            gap: 'Z',
            padding: 'A 0 0 0',
            borderTop: '1px solid surfaceBorderStrong',
            DocsHeader: {
              flow: 'x',
              align: 'center space-between',
              DocsTitle: {
                text: '{{ documentsLabel | polyglot }}',
                fontSize: 'A',
                fontWeight: '600',
                color: 'text'
              },
              CreateDocLink: {
                extends: 'Link',
                href: '/documents',
                text: '{{ createBtn | polyglot }}',
                fontSize: 'Z',
                color: 'green',
                textDecoration: 'none'
              }
            },
            EmptyDocs: {
              flow: 'y',
              align: 'center center',
              padding: 'A',
              background: 'surfaceCard',
              border: '1px solid surfaceBorderStrong',
              borderRadius: 'Z',
              EmptyDocIcon: {
                extends: 'Icon',
                icon: 'document',
                color: 'textMuted',
                width: 'A',
                height: 'A'
              },
              EmptyDocText: {
                text: '{{ noDocs | polyglot }}',
                fontSize: 'A',
                color: 'textMuted'
              }
            }
          }
        },

        // ═══ Tab: ecourt.ge ═══
        EcourtContent: {
          flow: 'y',
          gap: 'A',
          show: (el, s) => s.root.detailTab === 'ecourt',
          Desc: {
            text: '{{ ecourtDesc | polyglot }}',
            fontSize: 'Z',
            color: 'textSoft',
            lineHeight: '1.5'
          },
          Card1: {
            flow: 'y',
            gap: 'Y',
            padding: 'Z A',
            background: 'greenBg',
            border: '1px solid greenBorder',
            borderRadius: 'Z',
            CardTitle: {
              text: '{{ hearingSchedule | polyglot }}',
              fontSize: 'Z',
              fontWeight: '600',
              color: 'text'
            },
            CardItem1: {
              text: '{{ hearingItem1 | polyglot }}',
              fontSize: 'Y',
              color: 'textSoft'
            },
            CardItem2: {
              text: '{{ hearingItem2 | polyglot }}',
              fontSize: 'Y',
              color: 'textSoft'
            }
          },
          Card2: {
            flow: 'y',
            gap: 'Y',
            padding: 'Z A',
            background: 'greenBg',
            border: '1px solid greenBorder',
            borderRadius: 'Z',
            CardTitle: {
              text: '{{ caseStatus | polyglot }}',
              fontSize: 'Z',
              fontWeight: '600',
              color: 'text'
            },
            Step1: {
              flow: 'x',
              gap: 'Z',
              align: 'center',
              StepDot: {
                width: 'Y',
                height: 'Y',
                borderRadius: '100%',
                background: 'green',
                flexShrink: '0'
              },
              StepText: {
                text: '{{ claimFiled | polyglot }}',
                fontSize: 'Y',
                color: 'text'
              },
              StepStatus: { text: '✓', color: 'green' }
            },
            Step2: {
              flow: 'x',
              gap: 'Z',
              align: 'center',
              StepDot: {
                width: 'Y',
                height: 'Y',
                borderRadius: '100%',
                background: 'green',
                flexShrink: '0'
              },
              StepText: {
                text: '{{ claimAccepted | polyglot }}',
                fontSize: 'Y',
                color: 'text'
              },
              StepStatus: { text: '✓', color: 'green' }
            },
            Step3: {
              flow: 'x',
              gap: 'Z',
              align: 'center',
              StepDot: {
                width: 'Y',
                height: 'Y',
                borderRadius: '100%',
                background: 'amber',
                flexShrink: '0'
              },
              StepText: {
                text: '{{ prepHearing | polyglot }}',
                fontSize: 'Y',
                color: 'text'
              },
              StepStatus: { text: '⟳', color: 'amber' }
            }
          },
          Card3: {
            flow: 'y',
            gap: 'Y',
            padding: 'Z A',
            background: 'greenBg',
            border: '1px solid greenBorder',
            borderRadius: 'Z',
            CardTitle: {
              text: '{{ electronicFiling | polyglot }}',
              fontSize: 'Z',
              fontWeight: '600',
              color: 'text'
            },
            Doc1: {
              flow: 'x',
              gap: 'Z',
              align: 'center',
              DocIcon: { text: '📄', fontSize: 'Z' },
              DocInfo: {
                text: '{{ claimFiledDoc | polyglot }}',
                fontSize: 'Y',
                color: 'text',
                flex: '1'
              },
              DocStatus: { text: '✓', color: 'green' }
            },
            Doc2: {
              flow: 'x',
              gap: 'Z',
              align: 'center',
              DocIcon: { text: '📄', fontSize: 'Z' },
              DocInfo: {
                text: '{{ evidencePending | polyglot }}',
                fontSize: 'Y',
                color: 'amber',
                flex: '1'
              },
              DocStatus: { text: '⟳', color: 'amber' }
            }
          }
        },

        // ═══ Tab: საჯარო რეესტრი ═══
        ReestryContent: {
          flow: 'y',
          gap: 'A',
          show: (el, s) => s.root.detailTab === 'reestry',
          Desc: {
            text: '{{ registryDesc | polyglot }}',
            fontSize: 'Z',
            color: 'textSoft',
            lineHeight: '1.5'
          },
          Card1: {
            flow: 'y',
            gap: 'Y',
            padding: 'Z A',
            background: 'blueBg',
            border: '1px solid blueBorder',
            borderRadius: 'Z',
            CardTitle: {
              text: '{{ companyName | polyglot }}',
              fontSize: 'Z',
              fontWeight: '600',
              color: 'text'
            },
            Row1: {
              flow: 'x',
              gap: 'Z',
              Label: {
                text: '{{ idCode | polyglot }}',
                fontSize: 'Y',
                color: 'textMuted',
                minWidth: 'D'
              },
              Val: { text: '404789012', fontSize: 'Y', color: 'text' }
            },
            Row2: {
              flow: 'x',
              gap: 'Z',
              Label: {
                text: '{{ director | polyglot }}',
                fontSize: 'Y',
                color: 'textMuted',
                minWidth: 'D'
              },
              Val: {
                text: '{{ clientName1 | polyglot }}',
                fontSize: 'Y',
                color: 'text'
              }
            },
            Row3: {
              flow: 'x',
              gap: 'Z',
              Label: {
                text: '{{ address | polyglot }}',
                fontSize: 'Y',
                color: 'textMuted',
                minWidth: 'D'
              },
              Val: {
                text: '{{ addressVal | polyglot }}',
                fontSize: 'Y',
                color: 'text'
              }
            },
            Row4: {
              flow: 'x',
              gap: 'Z',
              Label: {
                text: '{{ statusLabel | polyglot }}',
                fontSize: 'Y',
                color: 'textMuted',
                minWidth: 'D'
              },
              Val: {
                text: '{{ activeTab | polyglot }}',
                fontSize: 'Y',
                color: 'blue',
                fontWeight: '600'
              }
            }
          },
          Card2: {
            flow: 'y',
            gap: 'Y',
            padding: 'Z A',
            background: 'blueBg',
            border: '1px solid blueBorder',
            borderRadius: 'Z',
            CardTitle: {
              text: '{{ registeredProperty | polyglot }}',
              fontSize: 'Z',
              fontWeight: '600',
              color: 'text'
            },
            Prop1: {
              flow: 'x',
              gap: 'Z',
              align: 'center',
              PropIcon: { text: '🏠', fontSize: 'Z' },
              PropText: {
                text: '{{ propertyApartment | polyglot }}',
                fontSize: 'Y',
                color: 'textSoft'
              }
            },
            Prop2: {
              flow: 'x',
              gap: 'Z',
              align: 'center',
              PropIcon: { text: '🚗', fontSize: 'Z' },
              PropText: {
                text: '{{ propertyCar | polyglot }}',
                fontSize: 'Y',
                color: 'textSoft'
              }
            }
          },
          Card3: {
            flow: 'y',
            gap: 'Y',
            padding: 'Z A',
            background: 'blueBg',
            border: '1px solid blueBorder',
            borderRadius: 'Z',
            CardTitle: {
              text: '{{ extract | polyglot }}',
              fontSize: 'Z',
              fontWeight: '600',
              color: 'text'
            },
            Ext1: {
              flow: 'x',
              gap: 'Z',
              align: 'center',
              ExtDate: {
                text: '{{ dateMar18 | polyglot }}',
                fontSize: 'Y',
                color: 'blue',
                fontWeight: '600'
              },
              ExtInfo: {
                text: '{{ companyExtractLoaded | polyglot }}',
                fontSize: 'Y',
                color: 'text',
                flex: '1'
              },
              ExtStatus: { text: '✓', color: 'blue' }
            },
            Ext2: {
              flow: 'x',
              gap: 'Z',
              align: 'center',
              ExtDate: {
                text: '{{ dateMar18 | polyglot }}',
                fontSize: 'Y',
                color: 'blue',
                fontWeight: '600'
              },
              ExtInfo: {
                text: '{{ propertyExtractAdded | polyglot }}',
                fontSize: 'Y',
                color: 'text',
                flex: '1'
              },
              ExtStatus: { text: '✓', color: 'blue' }
            }
          }
        },

        // ═══ Tab: matsne.gov.ge ═══
        MatsneContent: {
          flow: 'y',
          gap: 'A',
          show: (el, s) => s.root.detailTab === 'matsne',
          Desc: {
            text: '{{ matsneDesc | polyglot }}',
            fontSize: 'Z',
            color: 'textSoft',
            lineHeight: '1.5'
          },
          Card1: {
            flow: 'y',
            gap: 'Y',
            padding: 'Z A',
            background: 'purpleBg',
            border: '1px solid purpleBorder',
            borderRadius: 'Z',
            CardTitle: {
              text: '{{ recentChanges | polyglot }}',
              fontSize: 'Z',
              fontWeight: '600',
              color: 'text'
            },
            Change1: {
              flow: 'y',
              gap: 'Y',
              padding: 'Z 0',
              borderBottom: '1px solid surfaceBorderStrong',
              ChangeName: {
                text: '{{ change1Name | polyglot }}',
                fontSize: 'Y',
                fontWeight: '500',
                color: 'text'
              },
              ChangeDesc: {
                text: '{{ change1Desc | polyglot }}',
                fontSize: 'Y',
                color: 'textSoft'
              },
              ChangeDate: {
                text: '{{ change1Date | polyglot }}',
                fontSize: 'Y',
                color: 'purple'
              }
            },
            Change2: {
              flow: 'y',
              gap: 'Y',
              padding: 'Z 0',
              ChangeName: {
                text: '{{ change2Name | polyglot }}',
                fontSize: 'Y',
                fontWeight: '500',
                color: 'text'
              },
              ChangeDesc: {
                text: '{{ change2Desc | polyglot }}',
                fontSize: 'Y',
                color: 'textSoft'
              },
              ChangeDate: {
                text: '{{ change2Date | polyglot }}',
                fontSize: 'Y',
                color: 'purple'
              }
            }
          },
          Card2: {
            flow: 'y',
            gap: 'Y',
            padding: 'Z A',
            background: 'purpleBg',
            border: '1px solid purpleBorder',
            borderRadius: 'Z',
            CardTitle: {
              text: '{{ yourFieldChanges | polyglot }}',
              fontSize: 'Z',
              fontWeight: '600',
              color: 'text'
            },
            Field1: {
              flow: 'x',
              gap: 'Z',
              align: 'center',
              FieldDot: {
                width: 'Y',
                height: 'Y',
                borderRadius: '100%',
                background: 'purple',
                flexShrink: '0'
              },
              FieldText: {
                text: '{{ field1Text | polyglot }}',
                fontSize: 'Y',
                color: 'text',
                flex: '1'
              },
              FieldStatus: {
                text: '{{ newLabel | polyglot }}',
                fontSize: 'Y',
                color: 'purple',
                fontWeight: '600'
              }
            },
            Field2: {
              flow: 'x',
              gap: 'Z',
              align: 'center',
              FieldDot: {
                width: 'Y',
                height: 'Y',
                borderRadius: '100%',
                background: 'purple',
                flexShrink: '0'
              },
              FieldText: {
                text: '{{ field2Text | polyglot }}',
                fontSize: 'Y',
                color: 'text',
                flex: '1'
              },
              FieldStatus: {
                text: '{{ newLabel | polyglot }}',
                fontSize: 'Y',
                color: 'purple',
                fontWeight: '600'
              }
            },
            Field3: {
              flow: 'x',
              gap: 'Z',
              align: 'center',
              FieldDot: {
                width: 'Y',
                height: 'Y',
                borderRadius: '100%',
                background: 'blue',
                flexShrink: '0'
              },
              FieldText: {
                text: '{{ field3Text | polyglot }}',
                fontSize: 'Y',
                color: 'text',
                flex: '1'
              },
              FieldStatus: {
                text: '{{ newLabel | polyglot }}',
                fontSize: 'Y',
                color: 'blue',
                fontWeight: '600'
              }
            }
          },
          Card3: {
            flow: 'y',
            gap: 'Y',
            padding: 'Z A',
            background: 'purpleBg',
            border: '1px solid purpleBorder',
            borderRadius: 'Z',
            CardTitle: {
              text: '{{ notifications | polyglot }}',
              fontSize: 'Z',
              fontWeight: '600',
              color: 'text'
            },
            Setting1: {
              flow: 'x',
              gap: 'Z',
              align: 'center',
              SettingLabel: {
                text: '{{ typeCivil | polyglot }}',
                fontSize: 'Y',
                color: 'text',
                flex: '1'
              },
              SettingVal: {
                text: '{{ enabledStatus | polyglot }}',
                fontSize: 'Y',
                color: 'green',
                fontWeight: '600'
              }
            },
            Setting2: {
              flow: 'x',
              gap: 'Z',
              align: 'center',
              SettingLabel: {
                text: '{{ typeAdministrative | polyglot }}',
                fontSize: 'Y',
                color: 'text',
                flex: '1'
              },
              SettingVal: {
                text: '{{ enabledStatus | polyglot }}',
                fontSize: 'Y',
                color: 'green',
                fontWeight: '600'
              }
            },
            Setting3: {
              flow: 'x',
              gap: 'Z',
              align: 'center',
              SettingLabel: {
                text: '{{ typeCriminal | polyglot }}',
                fontSize: 'Y',
                color: 'text',
                flex: '1'
              },
              SettingVal: {
                text: '{{ disabledStatus | polyglot }}',
                fontSize: 'Y',
                color: 'textMuted'
              }
            }
          }
        }
      }
    }
  }
}
